import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={classes.footer}>
      <p className={classes.copyright}>
        &copy;{new Date().getFullYear()} Δήμος Πρέβεζας
      </p>
    </div>
  );
};

export default Footer;
